import { NavLink, Outlet, useMatch } from "react-router-dom";

export function Layout() {
  const isDetail = !!useMatch("/sessions/:id");
  return (
    <div className="app">
      <header className="app-header">
        <div className="brand">HAS2 Stats</div>
        <nav className="app-nav">
          <NavLink to="/" end>
            개요
          </NavLink>
          <NavLink to="/distribution">분포</NavLink>
          <NavLink to="/analysis">게임 분석</NavLink>
          <NavLink to="/devices">장치</NavLink>
          <NavLink to="/death-locations">생명 손실 위치</NavLink>
          <NavLink to="/detections">발각</NavLink>
          <NavLink to="/sessions">세션</NavLink>
        </nav>
      </header>
      <main className={`app-main ${isDetail ? "detail-main" : ""}`}>
        <Outlet />
      </main>
    </div>
  );
}
